import React, {FC} from 'react';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import {useTranslation} from 'react-i18next';
import {SxProps} from '@mui/material';

export const Loading: FC  = () => {

  const {t} = useTranslation();

  return <Box sx={styles.loadingBox}>
    <Paper sx={styles.paper} elevation={3}>
      <Typography variant="overline">{t('loading')}</Typography>
      <Box sx={styles.box}>
        <LinearProgress/>
      </Box>
    </Paper>
  </Box>;
};

export default Loading;

const styles: Record<string, SxProps> = {
  loadingBox: {
    height: '100vh',
    display: 'grid',
    placeItems: 'center',
    zIndex: 1000,
    position: 'fixed',
    inset: 0
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent:'center',
    alignItems: 'center',
    p: 3,
    width: '400px'
  },
  box: {
    width: '300px',
    mt: 1
  }
};